import {LifecycleKind, PlantSeason, Post} from '../types';
import {formatDayMonth} from './when';

// A crop's season as the lifecycle the plant page draws: sowed → potted on → planted out →
// progress → harvest. Every step is always present; an empty one is dim and hints at what
// happened at that step last season, which is the nudge to post.

export const LIFECYCLE_KINDS: LifecycleKind[] = ['sowed', 'potted', 'planted', 'progress', 'harvest'];

export interface LifecycleStep {
    kind: LifecycleKind;
    /** Ascending by whenLocal. */
    tells: Post[];
    /** For an empty step: "Last season: first on 4 Jan" or "nothing yet". */
    hint: string | null;
}

export interface Lifecycle {
    steps: LifecycleStep[];
    /** Everything of another kind this season (problems, feeds, chores, notes). */
    other: Post[];
}

const isLifecycleKind = (kind: string): kind is LifecycleKind => (LIFECYCLE_KINDS as string[]).includes(kind);

const byWhen = (a: Post, b: Post) => (a.whenLocal < b.whenLocal ? -1 : a.whenLocal > b.whenLocal ? 1 : 0);

export function deriveLifecycle(posts: Post[], previous?: PlantSeason | null): Lifecycle {
    const sorted = [...posts].sort(byWhen);
    const steps = LIFECYCLE_KINDS.map<LifecycleStep>(kind => {
        const tells = sorted.filter(p => p.kind === kind);
        const before = previous?.steps[kind];
        const hint = tells.length > 0 ? null : before ? `Last season: first on ${formatDayMonth(before.firstAt)}` : 'nothing yet';
        return {kind, tells, hint};
    });
    return {steps, other: sorted.filter(p => !isLifecycleKind(p.kind))};
}
